export function containsCyrillic(text) {
	const cyrillicRegex = /[\u0400-\u04FF]/;
	return cyrillicRegex.test(text);
}
